import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["children"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
* This source code is quoted from rc-tabs.
* homepage: https://github.com/react-component/tabs
*/
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import InkTabBarNode from './InkTabBarNode';
import TabBarTabsNode from './TabBarTabsNode';
import TabBarRootNode from './TabBarRootNode';
import ScrollableTabBarNode from './ScrollableTabBarNode';
import SaveRef from './SaveRef';

var ScrollableInkTabBar = /*#__PURE__*/function (_React$Component) {
  _inherits(ScrollableInkTabBar, _React$Component);

  var _super = _createSuper(ScrollableInkTabBar);

  function ScrollableInkTabBar() {
    _classCallCheck(this, ScrollableInkTabBar);

    return _super.apply(this, arguments);
  }

  _createClass(ScrollableInkTabBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      ReactDOM.findDOMNode(this).addEventListener('DNDclick', function (e) {
        if (e && e.detail && e.detail.key) {
          _this.props.onTabClick.call(_this, e.detail.key);
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;

      ReactDOM.findDOMNode(this).removeEventListener('DNDclick', function (e) {
        if (e && e.detail && e.detail.key) {
          _this2.props.onTabClick.call(_this2, e.detail.key);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          renderTabBarNode = _this$props.children,
          restProps = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement(SaveRef, null, function (saveRef, getRef) {
        return /*#__PURE__*/React.createElement(TabBarRootNode, _extends({
          saveRef: saveRef
        }, restProps), /*#__PURE__*/React.createElement(ScrollableTabBarNode, _extends({
          saveRef: saveRef,
          getRef: getRef
        }, restProps), /*#__PURE__*/React.createElement(TabBarTabsNode, _extends({
          saveRef: saveRef,
          renderTabBarNode: renderTabBarNode
        }, restProps)), /*#__PURE__*/React.createElement(InkTabBarNode, _extends({
          saveRef: saveRef,
          getRef: getRef
        }, restProps))));
      });
    }
  }]);

  return ScrollableInkTabBar;
}(React.Component);

export { ScrollableInkTabBar as default };
ScrollableInkTabBar.propTypes = {
  children: PropTypes.func
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tabs/src/ScrollableInkTabBar.js